import Icon from "@/components/Ui/Icon";
import ButtonMenu from "@/components/UserButton/ButtonMenu";
import useOnClickOutside from "@/hooks/use-click-outside";
import { useAuth0 } from "@auth0/auth0-react";
import Image from "next/legacy/image";
import { useRef, useState } from "react";

const UserButton = () => {
  const { user } = useAuth0();
  const { picture } = user || {};
  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef(null);

  useOnClickOutside(ref, () => {
    if (!isOpen) return;
    setIsOpen(false);
  });

  return (
    <>
      {isOpen && (
        <div className="fixed top-0 left-0 z-40 h-full w-full bg-black opacity-70" />
      )}
      {/* TODO: remove playwright mask sometime in the future and see if the 1px bug is gone */}
      <div className="relative z-40" ref={ref}>
        <a
          className="cursor-pointer space-x-2.5 text-sm"
          onClick={() => setIsOpen(!isOpen)}
          aria-label="Open user menu"
          data-apply-playwright-mask
        >
          <div className="bg-muted flex h-8 w-8 shrink-0 items-center justify-center rounded-full">
            {picture ? (
              <Image
                className="rounded-full"
                src={picture}
                alt="user picture"
                width={32}
                height={32}
              />
            ) : (
              <Icon name="avatar" />
            )}
          </div>
        </a>

        <ButtonMenu
          isOpen={isOpen}
          user={user}
          closeFunction={() => {
            setIsOpen(false);
          }}
        />
      </div>
    </>
  );
};

export default UserButton;
